/** English subscription plan labels (SpectraI). */
export const SUBSCRIPTION_PLAN_SLUGS = ['free', 'basic', 'medium', 'premium'] as const

export type SubscriptionPlanSlug = (typeof SUBSCRIPTION_PLAN_SLUGS)[number]

const PLAN_LABELS: Record<SubscriptionPlanSlug, string> = {
  free: 'Free',
  basic: 'Basic',
  medium: 'Medium',
  premium: 'Premium',
}

/** User-facing plan title by slug; ignores legacy RU names from API. */
export function subscriptionPlanLabel(slug: string, fallback?: string | null): string {
  if (slug in PLAN_LABELS) {
    return PLAN_LABELS[slug as SubscriptionPlanSlug]
  }
  return fallback?.trim() || slug
}
